import ProviderDetails from './ProviderDetails'
export default ProviderDetails
